import React from 'react'

import type { WCDRouteProps } from '..'
import { Page } from '../components/Page'

export const authorRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: '/:filterSlug(author)/:filterValue',
    component: () => (
      <Page pagePath="article-listing/ArticleListingPage" template="Author Listing" />
    ),
  },
]
